export default "__VITE_ASSET__667e8a76__"